<template>
  <div class="write">
    <h1>{{ $t("message.write_title") }}</h1>
    <b-field>
      <b-input v-model="content" type="textarea" :placeholder="$t('message.write_title')" maxlength="400"></b-input>
    </b-field>
    <b-button type="is-info" @click="send">{{ $t("message.write_btn") }}</b-button>
    <hr />
    <AdComponent />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
import store from '@/store'
import AdComponent from  './../components/AdComponent.vue'
export default {
    components:{
        AdComponent
    },
    name: 'write',
    data(){
        return{
            content: null
        }
    },
    computed: {
        user(){
            return this.$store.getters.user;
        }
    },
    mounted(){
        const title = "登録画面｜メモや日記ついでに英語学習"
        const description = "メモや日記ついでに英語学習の登録画面です。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },
    methods: {
        send(){
            if(this.content){
                store.commit('start')
                var new_doc_Id = firebase.firestore().collection("text").doc();
                console.log(new_doc_Id)
                new_doc_Id.set({
                    uid: this.user.uid,
                    content: this.content,
                    createdAt: new Date(),
                    createdDay: moment().locale('ja').format('l')
                },{ merge: true }).then(()=>{
                    this.$buefy.toast.open('登録完了しました！')
                    store.commit('end')
                    this.$router.push({ name: 'translate_result', params:{ id: new_doc_Id.id} })
                    this.content = null
                }).catch(function() {
                    this.$buefy.toast.open('おや？登録に失敗しました');
                    store.commit('end');
                });
            }
        }
    }
}
</script>

<style scoped>
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
.write{
  padding-left:10px;
  padding-right: 10px;
}
</style>